import React, { Component } from 'react'
import _ from 'lodash'
import {  Col, FormGroup, Popover } from "react-bootstrap";
import {  Field, reduxForm, propTypes,formValueSelector,change } from 'redux-form'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { PropTypes } from 'prop-types'
import { saveEventDetails,setEventSponsor,setCorrectEventDetails,setJVEvent } from "../../../../redux/actions/action_event"
import {  videoblue,warning,forms,lblattrsWide, inputattrsSmall,box,sponsors,gender } from "../../../../utils/constants"
import ModalWindow from '../../../../utils/modalwindow'
import { renderOptionsField } from '../../../../modules/components/fieldoptioncomponent'
import { renderChecboxField } from '../../../../modules/components/checkboxfieldcomponent'
import { renderOptionsFieldSingle } from '../../../../modules/components/fieldoptioncomponentsingle'
import CorrectEventInfo from "../CorrectEventInfo"
import EventDetailsFields  from './fields'

const FormName = forms.eventinfo
const readOnly = {
	fontWeight:'bold',minWidth:'100px',textAlign:'left' 
}

class EventDetails extends Component {
 
    static propTypes = {
        ...propTypes
	}

    constructor(props)
    {  
			super(props)
		/* 	this.state =
			{
				jvevent:'true'
			} */
			this.handleEventGenderChange = this.handleEventGenderChange.bind(this)
			this.handleEventSponsorChange = this.handleEventSponsorChange.bind(this)
			this.handleValidInfo = this.handleValidInfo.bind(this)
			this.handleJVParticipationChange  = this.handleJVParticipationChange.bind(this)
			this.handleQualifyingFormatChange = this.handleQualifyingFormatChange.bind(this) 
			this.displayWarning   = this.displayWarning.bind(this)
			this.notifyWrongTeams =   this.notifyWrongTeams.bind(this)
			this.areDetailsEqual  = this.areDetailsEqual.bind(this)
			this.getGenderDescription = this.getGenderDescription.bind(this)
			this.getSponsorDescription = this.getSponsorDescription.bind(this)
			this.getJVSection = this.getJVSection.bind(this)
    }
    componentDidMount(){
			window.scrollTo(0, 0)
    }
    componentDidUpdate()
    {
			const { participantschools,eventgendermen, eventgenderwomen,eventjvgenderwomen,eventjvgendermen,hasCheckedTeamSelection,dispatch } = this.props
			
			if(eventjvgenderwomen === false && eventjvgendermen === false)
			{
				dispatch(change(FormName, EventDetailsFields.JVEVENT,"false"))
			}
			// check if there is an existing participant list and if it contains the right genders   
			if((participantschools !== undefined) && (participantschools.length > 0) && !hasCheckedTeamSelection)	{
				let wrongteams = null
				if(eventgendermen === false)
				{
					wrongteams = _.find(participantschools,['menteam',true])
					if(wrongteams !== undefined)
					{
						this.notifyWrongTeams()
					}
				}
				if(eventgenderwomen === false){
					wrongteams = _.find(participantschools,['womenteam',true])
					if(wrongteams !== undefined)
					{
						this.notifyWrongTeams()
					}
				}
			}
    }
    componentWillUnmount()
    {
			const { areDetailsEqual } = this
			const { 
				dispatch, eventgenderwomen,eventgendermen,eventsponsor,eventId,
				eventjvgendermen,eventjvgenderwomen,jvevent ,eventtier,eventsamequalifyingformat,prestineeventdetails 
			} = this.props
			dispatch(change(FormName,'hasCheckedTeamSelection',false))
			const saveDetails   = !areDetailsEqual(prestineeventdetails,this.props)
			// if information has not changed then there is no need to save it
			if (saveDetails) {
				const details = {
					eventId:eventId,
					isEventMen:eventgendermen,
					isEventWomen:eventgenderwomen,
					sponsor:eventsponsor,
					step:2,
					hasJVMen: eventjvgendermen,
					hasJVWomen:eventjvgenderwomen,
					tier:eventtier,
					hasJVDivision:jvevent === "true" ? true:false,
					hasSameQualifyingFormat:eventsamequalifyingformat
				}
				dispatch(saveEventDetails(details))
			}
    }
    notifyWrongTeams(){
			const { dispatch } = this.props
			dispatch(change(FormName,'wrongparticipantselection',true))
			dispatch(change(FormName,'hasCheckedTeamSelection',true))
    }
    displayWarning=(title,message,trigger) => {
			const { dispatch } = this.props  
			return (<ModalWindow 
				title={title} 
				trigger={trigger}
				message={message}
				dispatch={dispatch} 
			/>)
    }
		handleValidInfo (isValid) 
    {
			const { dispatch,eventId } = this.props
			dispatch(setCorrectEventDetails(eventId,isValid,'none'))
    }
    handleJVParticipationChange(event)
    {
			const { dispatch } = this.props
			//console.log('handleJVParticipationChange event.target.value value',typeof(event.target.value),event.target.value)
			const jvevent = event.target.value === "true" ? true:false
			dispatch(setJVEvent(jvevent))
			//const jvevent = event.target.value === "true" ? true:false
			/* dispatch(change(FormName,'eventjv',event.target.value))
			dispatch(change(FormName,'eventjvgendermen',jvevent))
			dispatch(change(FormName,'eventjvgenderwomen',jvevent)) */
    }
    handleEventSponsorChange(event)
    {
			const { target } = event
			const { value }= target
			const { dispatch,setEventSponsor } = this.props
     
			dispatch(setEventSponsor(value))
    }
    handleEventGenderChange(event)
    {
			// cannot have women only varisity event and men and women jv events
			const gender = event.target.id
			const { dispatch,eventsamequalifyingformat } = this.props

			if (eventsamequalifyingformat === 'false')
			{
				(
					gender === EventDetailsFields.GENDERMEN) ? 
					dispatch(change(FormName,EventDetailsFields.GENDERWOMEN,false)) :
					dispatch(change(FormName,EventDetailsFields.GENDERMEN,false)
				) 
			}   
    }
    handleQualifyingFormatChange(event)
    {  
			const value = event.target.value 
			const { dispatch } = this.props
			const differentformat = "false"

			if (value === differentformat)
			{
				// if formats are different for men and women then they have to be setup as different events. We will proceed as men by default
				dispatch(change(FormName, EventDetailsFields.GENDERWOMEN,false))
				dispatch(change(FormName, EventDetailsFields.JVGENDERWOMEN,false))
			}
    }
		areDetailsEqual (original,current) {
				let equal = true

				if((original != undefined) && (current != undefined))
				{
					if (	original.eventgenderwomen != current.eventgenderwomen	) {
						equal = false
					}
					if (	original.eventgendermen != current.eventgendermen	) {
						equal = false
					}
					if (	original.eventsponsor != current.eventsponsor.toString()	) {
						equal = false
					}
					if (	original.eventjvgendermen != current.eventjvgendermen	) {
						equal = false
					}
					if (	original.eventjvgenderwomen != current.eventjvgenderwomen	) {
						equal = false
					}
					if (	original.eventjv != current.jvevent.toString()	) {
						equal = false
					}
					if (	original.eventtier != current.eventtier.toString()	) {
						equal = false
					}
					if (	original.eventsamequalifyingformat != current.eventsamequalifyingformat.toString()	) {
						equal = false
					}	
				}
				else {
					equal = false
				}
				return equal		
		}
		getSponsorDescription()
		{
			const { eventsponsor } = this.props
			switch(eventsponsor)
			{
				case '1':
					return 'USBC'
				case '2':
					return 'NCAA'
				case '3':
					return 'NJCAA'
				case '4':
					return 'NAIA'
			}
		}
		getGenderDescription()
		{
			const { eventgendermen,eventgenderwomen } = this.props
			if(eventgendermen && eventgenderwomen)
			{
				return(
					[	<i key='1' className='fa fa-male' aria-hidden='true' style={{ opacity:'0.5' }}  />,
						<i key='2' className='fa fa-female' aria-hidden='true' style={{ color:warning,opacity:'0.5' }}  />,
						<span key='3'>{'  '}&nbsp;Men and Women event</span>
					]
				)
			}
			else if(eventgendermen && !eventgenderwomen)
			{
			return (
					[
						<i key='1' className='fa fa-male' aria-hidden='true'  />,
						<span key='2'>{'  '}&nbsp;Men only event</span>
					]
				)
			}
			else if(!eventgendermen && eventgenderwomen)
			{
				return 	(
					[<i key='1' className='fa fa-female' aria-hidden='true' style={{ color:warning,opacity:'0.5' }}  />,
									<span key='2'>{'  '}&nbsp;Women only event</span>]
				)
				
			}
		}
		getJVSection()
		{
			const { jvevent } = this.props
			const _this = this

			console.log('this is the jvevent value', jvevent,typeof(jvevent))
			
			return (
			[	
				<Col  key='1'>	
					<label key='1' style={readOnly}>JV Divisions:</label>	
					<label className="radio-inline c-radio"  >
						<input id="jvevent" type="radio" name="jvevent"  value="true" checked={jvevent === "true"} onChange={_this.handleJVParticipationChange} />
						<em className="fa fa-circle" style={{ color:'rgb(255,144,43)' }} />&nbsp;&nbsp;Yes
					</label> 
					<label className="radio-inline c-radio"  >
						<input id="jvevent" type="radio" name="jvevent"  value="false" checked={jvevent === "false"} onChange={_this.handleJVParticipationChange} />
						<em className="fa fa-circle" style={{ color:'rgb(255,144,43)' }}  />&nbsp;&nbsp;No 
					</label>    										
				</Col>,
				<Col  key='2' smOffset={2} style={{ marginLeft:'100px' }}>
					<label className="checkbox-inline c-checkbox">
						<input   type="checkbox" 
							value = { _this.props.eventjvgendermen }  
							name = {EventDetailsFields.JVGENDERMEN } 
							id = { EventDetailsFields.JVGENDERMEN }  
							checked = {                                                      // changed from defaultChecked
								_this.props.eventjvgendermen && 
								_this.props.eventsponsor !== sponsors.NCAA && 
								_this.props.eventgendermen && 
								_this.props.jvevent === 'true'
							} 
							//checked={_this.props.eventjvgendermen}
							disabled= {
								_this.props.eventsponsor === sponsors.NCAA || 
								jvevent === "false" ||
								_this.props.eventgendermen === false
							} 
						/>
						<em className="fa fa-check" />&nbsp;&nbsp;{gender.Men}
					</label> 
					<label className="checkbox-inline c-checkbox">
						<input   type="checkbox" 
							name = { EventDetailsFields.JVGENDERWOMEN } 
							id = { EventDetailsFields.JVGENDERWOMEN }  
							checked = {                                                       // changed from defaultChecked
								_this.props.eventjvgenderwomen && 
								_this.props.eventgenderwomen && 
								_this.props.jvevent === 'true' 
							} 
							//checked={_this.props.eventjvgenderwomen}
							disabled = {
								jvevent === "false" || 
								_this.props.eventgenderwomen === false
							} 
							value = { _this.props.eventjvgenderwomen }  	
						/>
						<em className="fa fa-check" />&nbsp;&nbsp;{gender.Women}
					</label> 
				</Col>   
			]
			)              
		
		}
    render() {
			const { 
				eventname,
				user,
				eventtier, 
				eventgenderwomen, 
				eventgendermen,
				eventjvgendermen, 
				eventjvgenderwomen, 
				isEventDetailsVerified,
				jvevent,
				eventsponsor,
				eventsamequalifyingformat,
				handleSubmit, 
				wrongparticipantselection,
				previousPage,
				savingData 
			} = this.props  
			const { isAdministrator } = user
			const samequalifyingformat = "true"
			const differentqualifyingformat =  "false"      
			const eventSponsors = Object.getOwnPropertyNames(sponsors) 
			const imageIcon = savingData ? 'fa fa-spinner fa-spin':"fa fa-caret-right"
			const popoverRight = (<Popover  id='poright' title='Warning!!' style={{ color:warning,minWidth:'350px' }}>
				<em className="fa fa-exclamation-triangle" style={{ color:warning }} />&nbsp;&nbsp;
				<span>Enter as separate events for each format type.</span>
			</Popover>)

     /*  const hasJV = eventjvgendermen || eventjvgenderwomen
			this.setState({ jvevent:hasJV })
		 */
			return (
				<div style={{ marginTop:'1%' }} sm={12}>
					{
						wrongparticipantselection  && 
						(this.displayWarning('Wrong gender schools','Please notify tournament director about wrong gender team(s) in the participant schools list.','wrongparticipantselection' ))
					}    
					<form  onSubmit={handleSubmit} className="form-horizontal">
					<FormGroup style={{ padding:'0 0 0 25px', marginBottom:'0' }}>
								<h4 style={{ color:videoblue }}>{' '}Details - <span style={{ color:'green' }}>{_.startCase(_.toLower(eventname))}   </span></h4>
					</FormGroup>	
					{	
						isAdministrator &&	 
						(<Col style={box}>
									
							<Field
								label='Tier'
								labelattrs = {lblattrsWide}
								inputattrs = {inputattrsSmall}
								name={EventDetailsFields.TIER}
								id={EventDetailsFields.TIER}
								values={[
									{ name:'Tier 2', abbreviation:'2' },
									{ name:'Tier 1', abbreviation:'1', disabled:eventsponsor !== sponsors.USBC }
								]}											
								component={renderOptionsField}
								defaultvalue={eventtier}
							/>
							<Field
								label='Sponsor'
								labelattrs = {lblattrsWide}
								inputattrs = {inputattrsSmall}
								name={EventDetailsFields.SPONSOR}
								id={EventDetailsFields.SPONSOR}
								values={[
										{ name:eventSponsors[0], abbreviation:sponsors.USBC },
										{ name:eventSponsors[1], abbreviation:sponsors.NCAA  },
										{ name:eventSponsors[2], abbreviation:sponsors.NJCAA },
										{ name:eventSponsors[3], abbreviation:sponsors.NAIA },
								]}
								onChange={this.handleEventSponsorChange}
								component={renderOptionsField}
								defaultvalue={eventsponsor}
							/>
							<div className='form-group'>
								<label className={lblattrsWide}>Gender</label>
								<Col sm={ 8 }>
									<Field
										label =  {gender.Men}
										name= {EventDetailsFields.GENDERMEN}  
										id={EventDetailsFields.GENDERMEN}
										value    = { eventgendermen }               
										checked={ eventgendermen && (eventsponsor !== sponsors.NCAA) }
										component={  renderChecboxField  } 
										onChange={this.handleEventGenderChange} 
										disabled={eventsponsor === sponsors.NCAA}                        
									/>
									<Field
										label =  {gender.Women}
										name= {EventDetailsFields.GENDERWOMEN}
										id= {EventDetailsFields.GENDERWOMEN}                     
										checked={ eventgenderwomen  }
										component={  renderChecboxField  } 
										onChange={this.handleEventGenderChange}   
										value    = { eventgenderwomen }                      
									/>
								</Col>    
							</div>
							<FormGroup disabled={ !(eventgenderwomen && eventgendermen)  } hidden={ eventsponsor === sponsors.NCAA}>
								<label className={lblattrsWide}>Same qualifying format for both genders?</label>
								<Col sm={8 } md={8} lg={7}>												
									<Field
										label =  'Same'
										name= {EventDetailsFields.SAMEQUALIFYINGFORMAT}    
										id= {EventDetailsFields.SAMEQUALIFYINGFORMAT}                     
										component={renderOptionsFieldSingle} 
										disabled={!eventsamequalifyingformat}     
										optionvalue  = { samequalifyingformat }      
										defaultvalue=    { eventsamequalifyingformat }
										onChange={this.handleQualifyingFormatChange} 
									/>														
									<Field
										label =  'Different'
										name= {EventDetailsFields.SAMEQUALIFYINGFORMAT}  
										id= {EventDetailsFields.SAMEQUALIFYINGFORMAT}                       
										component={renderOptionsFieldSingle} 
										disabled={!eventsamequalifyingformat}     
										optionvalue    = { differentqualifyingformat }     
										popover={popoverRight}   
										defaultvalue=    { eventsamequalifyingformat }  
										onChange={this.handleQualifyingFormatChange}      
									/>
								</Col>
							</FormGroup>
							<FormGroup hidden={eventsponsor === sponsors.NCAA}>
									<label className={lblattrsWide}>JV Divisions</label>
									<Col sm={8 } md={8} lg={7}>												
										<Field
											label =  'Yes'
											name = {EventDetailsFields.JVEVENT}    
											id = {EventDetailsFields.JVEVENT}                     
											component = {renderOptionsFieldSingle}     
											optionvalue = "true"      
											defaultvalue = { jvevent }
											onChange = {this.handleJVParticipationChange}
										/>
										<Field
											label =  'No'
											name = {EventDetailsFields.JVEVENT}  
											id = {EventDetailsFields.JVEVENT}                       
											component = {renderOptionsFieldSingle}   
											optionvalue = "false"     
											defaultvalue = { jvevent }  
											onChange = {this.handleJVParticipationChange}    
										/>                  
									</Col>
									<Col lgOffset={4} smOffset={4} sm={8 } md={5} lg={5}>
										<Field
											label =  {gender.Men}
											name = {EventDetailsFields.JVGENDERMEN}  
											value = {eventjvgendermen}               
											checked = { eventjvgendermen && (eventsponsor !== sponsors.NCAA) && eventgendermen }
											component = {renderChecboxField}  
											disabled = {eventsponsor === sponsors.NCAA || jvevent === "false" || eventgendermen === false}                  
										/>
										<Field
											label =  {gender.Women}
											name = {EventDetailsFields.JVGENDERWOMEN}                     
											checked ={ eventjvgenderwomen && eventgenderwomen  }
											component ={renderChecboxField} 
											disabled = { jvevent === "false"  || eventgenderwomen === false}    
											value = {eventjvgenderwomen}                
										/>
									</Col>                 
								</FormGroup>
						</Col>)} 

						{ 
							!isAdministrator && 
							([<Col md={12} lg={6} key='1' style={{  padding:'15px' , marginRight:'0px', marginBottom:'15px',fontSize:'120%' }}>			
								<label style={readOnly}>Tier:</label>&nbsp;&nbsp;{eventtier}
								<br/>
								<label style={readOnly}>Sponsor:</label>&nbsp;&nbsp;{this.getSponsorDescription()}
								<br/>
								<label style={readOnly}>Gender:</label>&nbsp;&nbsp;{this.getGenderDescription()}
								<br/>
								<label style={readOnly}>Same qualifying format for both genders?:</label>&nbsp;&nbsp;{eventsamequalifyingformat ? 'Yes':'No'}
								<br/>
								
								{this.getJVSection(true)}
																
							</Col>,
							<Col sm={12} key='2' style={{ marginTop:'10px' }} >
								{   
									!isEventDetailsVerified  && <CorrectEventInfo onInfoIsCorrect={this.handleValidInfo} />
								} 
							</Col>])
						}
						<Col sm={12}>
							<button type="button" className="btn btn-primary pull-left previous" onClick={previousPage} style={{ fontSize:'120%',fontWeight:'bold'  }} >
								<i className="fa fa-caret-left" aria-hidden="true"  />&nbsp;&nbsp;Previous
							</button>
							<button type="submit" className="btn btn-primary pull-right next" style={{ minWidth:'120px', fontSize:'120%',fontWeight:'bold' }}>
								<i className={imageIcon} aria-hidden="true"  />&nbsp;&nbsp; Next 
							</button>              
						</Col>
					</form>   
        </div>)
		}
}
function mapStateToProps(state,ownProps){
	const formName =  ownProps.form
	const selector = formValueSelector(formName)
	const eventId               = selector(state,'eventId')
	const eventtier             = selector(state,EventDetailsFields.TIER)
	const eventname             = selector(state,'eventname')
	const eventgendermen        = selector(state,EventDetailsFields.GENDERMEN)
	const eventgenderwomen      = selector(state,EventDetailsFields.GENDERWOMEN)
	const eventDetailsIsCorrect = selector(state,'eventDetailsIsCorrect')
	const jvevent               = selector(state,EventDetailsFields.JVEVENT)
	const eventsponsor              = selector(state,EventDetailsFields.SPONSOR)
	const eventsamequalifyingformat = selector(state,EventDetailsFields.SAMEQUALIFYINGFORMAT)
	const eventjvgendermen          = selector(state,EventDetailsFields.JVGENDERMEN)
	const eventjvgenderwomen        = selector(state,EventDetailsFields.JVGENDERWOMEN)
	const isEventDetailsVerified    = selector(state,EventDetailsFields.IS_EVENT_DETAILS_VERIFIED)
	const participantschools        = selector(state,'participantschools')
	const wrongparticipantselection = selector(state,'wrongparticipantselection')
	const hasCheckedTeamSelection   = selector(state,'hasCheckedTeamSelection')
	const savingData                = selector(state,'savingData')
	const prestineeventdetails      = selector(state,'prestineeventdetails')

	return {
		eventname,
		eventtier,
		eventgendermen,
		eventgenderwomen,
		eventjvgendermen,
		eventjvgenderwomen,
		eventDetailsIsCorrect,
		eventsponsor ,
		jvevent,
		eventsamequalifyingformat,
		participantschools,
		wrongparticipantselection,
		hasCheckedTeamSelection,
		eventId,
		savingData,
		isEventDetailsVerified,
		prestineeventdetails,
		user:state.user
	}
}  
function mapDispatchToProps(dispatch){
	return bindActionCreators({
		saveEventDetails,
		setEventSponsor,
		setCorrectEventDetails,
		setJVEvent
	},dispatch)
}
EventDetails.propTypes = {
	handleSubmit:PropTypes.func,
	previousPage:PropTypes.func,
	dispatch:PropTypes.func,
	saveEventDetails: PropTypes.func,
	setEventSponsor:PropTypes.func,
	eventgendermen: PropTypes.bool,
	eventgenderwomen: PropTypes.bool,
	eventjvgenderwomen: PropTypes.bool,
	eventjvgendermen: PropTypes.bool,
	eventDetailsIsCorrect: PropTypes.bool,
	eventId:PropTypes.number,
	jvevent:PropTypes.string,
	eventname:PropTypes.string,
	eventsponsor:PropTypes.string,
	eventsamequalifyingformat:PropTypes.string,
	eventtier:PropTypes.string,
	participantschools:PropTypes.array,
	wrongparticipantselection:PropTypes.bool,
	hasCheckedTeamSelection:PropTypes.bool,
	savingData:PropTypes.bool,
	isEventDetailsVerified:PropTypes.bool,
	prestineeventdetails:PropTypes.object,
	setJVEvent:PropTypes.func,
	user:PropTypes.object,
}
function validate(values) {
	const errors = {}
	// console.log('validate inside eventdetails', errors)
	if(!values){
		errors.jvevent = 'Please indicate jv participation'
	}
	return errors
}
export default reduxForm({
	validate,
	form:FormName,
	destroyOnUnmount: false,
	forceUnregisterOnUnmount: false
})(connect(mapStateToProps,mapDispatchToProps)(EventDetails))
    



// WEBPACK FOOTER //
// ./src/containers/event/EventWizard/EventDetails/index.js